import script from "./sf-skeleton-loader.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-skeleton-loader.vue?vue&type=script&lang=ts&setup=true"

import "./sf-skeleton-loader.vue?vue&type=style&index=0&id=7445861f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7445861f"]])

export default __exports__